// Version 4 (29.10.2026): Menüspalten und Fußzeile für „Produkte und Anlagen“ nach dem Katalog (Struktur nach BuyParto).
// Im Mega Menü stehen je Gruppe die wichtigsten Einträge plus „Alle …“; die vollständigen Listen stehen auf den Gruppenseiten.
import { CATALOG, GROUP_PATH } from "@/v4/content/catalog";

const TOP = {
    komponenten: ["sps-steuerungen", "frequenzumrichter", "servomotoren-antriebstechnik", "hmi-bediengeraete", "robotik", "sensoren", "antriebstechnik", "pneumatik"],
    maschinen: ["metallbearbeitung", "kunststoffmaschinen", "holzbearbeitung", "produktionsanlagen", "maschinenersatzteile"],
    hersteller: ["siemens", "beckhoff", "allen-bradley", "festo", "sew-eurodrive", "danfoss", "kuka", "fanuc"],
};
const TITLE = { komponenten: "Komponenten und Automation", maschinen: "Maschinen und Anlagen", hersteller: "Hersteller" };
// 02.11.2026 (K2a): „Alle Kategorien“ heißt bei Komponenten „Alle Industriegüter“
const ALL = { komponenten: "Alle Industriegüter", maschinen: "Alle Maschinen und Anlagen", hersteller: "Alle Hersteller" };

const pick = (g) => TOP[g].map((id) => CATALOG[g].find((c) => c.id === id)).filter(Boolean);

// 02.11.2026 (K2, K3): zwei Spalten statt drei. Je Spalte zuerst „Alle Hersteller“ und die Gruppenübersicht,
// danach alle Kategorien der Gruppe in Katalogreihenfolge. Komponenten (14) laufen über zwei Unterspalten (split).
export const v4ProductCols = () =>
    ["komponenten", "maschinen"].map((g) => ({
        title: TITLE[g],
        split: g === "komponenten",
        items: [
            { label: ALL.hersteller, to: GROUP_PATH.hersteller, kind: "brands" },
            { label: ALL[g], to: GROUP_PATH[g], kind: "all" },
            ...CATALOG[g].map((c) => ({ label: c.de, to: c.path })),
        ],
    }));

// Fußzeile: je Gruppe Überschrift und kurze Liste
export const v4ProductFooter = () =>
    ["komponenten", "maschinen", "hersteller"].flatMap((g) => [
        { heading: TITLE[g] },
        ...pick(g).slice(0, g === "maschinen" ? 5 : 4).map((c) => ({ label: c.de, to: c.path })),
        { label: ALL[g], to: GROUP_PATH[g] },
    ]);
